export default {
  site_name: '土豪漫画网',
  site_subtitle: '伪装学渣漫画 - 免费阅读下拉式漫画',
  home: '首页',
  categories: '分类',
  about: '关于我们',
  read_now: '立即阅读',
  view_more: '查看更多',
  popular: '热门推荐',
  latest: '最近更新',
  ranking: '排行榜',
  contact: '联系我们',
  not_found: '页面未找到',
  back_home: '返回首页',
};